export const Structs = {
    // struct that contains info
    SearchInfo() {
        return {
            list: [],
            query: "",
            isLoading: false
        }
    },

    /****************************************************/
    /*                      REQUESTS                    */
    /****************************************************/
    SimpleUserIdentification() {
        return {
            "afm": "",
            "efsa": "",
            "email": "",
        };
    },

    Credentials() {
        return {
            "confirmationToken": "",
            "password": "",
            "username": ""
        };
    },


    SimpleUser() {
        return {
            "afm": {
                "efAfm": "",
                "efAmka": "",
                "efEmail": "",
                "efSa": ""
            },
            "efedros": {
                "diavMeeAstByEfAstKwd": {
                    "astEidosYphr": 0,
                    "astKodikosIerarx": "",
                    "astKodikosYphr": 0,
                    "astKodikosYphrPal": 0,
                    "astOdosArith": "",
                    "astOnoma": "",
                    "tkKodikos": ""
                },
                "diavMeeEpaggelmaByEfEpagelma": {
                    "epagKwd": 0,
                    "epagLekt": "",
                    "epagSynt": ""
                },
                "diavMeeEpipedoMorfwshsByEfSxolEtos": {
                    "epipMorfKwd": 0,
                    "epipMorfLekt": "",
                    "epipMorfSynt": ""
                },
                "diavMeeGeoByGeoAmErgasias": {
                    "astKodikosYphr": 0,
                    "geoAm": 0,
                    "geoArthro": 0,
                    "geoDhm": "",
                    "geoDhmos": "",
                    "geoEda": "",
                    "geoEndeixh": "",
                    "geoEpa": "",
                    "geoEparx": "",
                    "geoEpistrNomosAlpha": 0,
                    "geoKallikraths": "",
                    "geoKathg": 0,
                    "geoNom": "",
                    "geoNomos": "",
                    "geoNomosEpan": 0,
                    "geoOikAa": "",
                    "geoOnoma": "",
                    "geoPlhthysmos": 0,
                    "geoYpagwgh": "",
                    "geoYpagwghEsye": "",
                    "geoYpsom": 0,
                    "tkKodikos": ""
                },
                "diavMeeGeoByTopoKwdErgasias": {
                    "astKodikosYphr": 0,
                    "geoAm": 0,
                    "geoArthro": 0,
                    "geoDhm": "",
                    "geoDhmos": "",
                    "geoEda": "",
                    "geoEndeixh": "",
                    "geoEpa": "",
                    "geoEparx": "",
                    "geoEpistrNomosAlpha": 0,
                    "geoKallikraths": "",
                    "geoKathg": 0,
                    "geoNom": "",
                    "geoNomos": "",
                    "geoNomosEpan": 0,
                    "geoOikAa": "",
                    "geoOnoma": "",
                    "geoPlhthysmos": 0,
                    "geoYpagwgh": "",
                    "geoYpagwghEsye": "",
                    "geoYpsom": 0,
                    "tkKodikos": ""
                },
                "diavMeeMonadaEpistrByMoepEa": {
                    "email": "",
                    "moepApothMonada": 0,
                    "moepEa": 0,
                    "moepEaDiathThnEfedria": 0,
                    "moepGeoApoth": 0,
                    "moepGeoParoys": 0,
                    "moepGeoSygrot": 0,
                    "moepKwd": 0,
                    "moepLektTopoyApoth": "",
                    "moepLektTopoyParoys": "",
                    "moepLektTopoyParoysOxh": "",
                    "moepLektTopoySygrot": "",
                    "moepSygrotMonada": 0,
                    "phone": ""
                },
                "diavMeeGeoByEfGeoDiam": {
                    "geoAm": 0,
                    "geoOnoma": "",
                    "geoNomos": "",
                    "geoDhmos": "",
                    "geoKallikraths": "",
                },
                "diavMeeSxolhByEfSxol": {
                    "sxolKwd": 0,
                    "sxolLekt": "",
                    "sxolSynt": ""
                },
                "diavMeeXwraByEfSxolXwra": {
                    "geoAm": 0,
                    "xwraKwd": 0,
                    "xwraLekt": "",
                    "xwraSynt": ""
                },
                "efAdiavUsername": "",
                "efArith": "",
                "efAstKwd": 0,
                "efEaFap": 0,
                "efEaPinakaE": 0,
                "efEpagelma": 0,
                "efEpwnymo": "",
                "efGeoDiam": 0,
                "geoAmErgasias": 0,
                "efKl": 0,
                "efOdos": "",
                "efOnoma": "",
                "efOnomaM": "",
                "efOnomaP": "",
                "efSa": "",
                "efSxol": 0,
                "efSxolEtos": 0,
                "efSxolXwra": 0,
                "efTk": "",
                "efp": 0,
                "isblocked": false,
                "moepEa": 0,
                "mhtrwoArrenwn": "",
                "efExeidikeysh": "",
                "activeReservist": false,
                "useSkills": false,
                "agreement": false,
                "expertiseArea": 0,
                "expertiseSkill": "",
                "skillDesc": "",
            },
            "swmatometrika": {
                "efSa": "",
                "swmaBaros": 0,
                "swmaMhkosKavaloy": 0,
                "swmaMhkosPelmatos": 0,
                "swmaPerifLaimoy": 0,
                "swmaPerifMeshs": 0,
                "swmaPerifPelmatos": 0,
                "swmaPerifSththoys": 0,
                "swmaYpsos": 0
            },
            "exwteriko": {
                "diavMeeXwraByExwtXwraKwd": {
                    "xwraKwd": "",
                    "xwraLekt": "",
                    "xwraSynt": "",
                    "geoAm": "0"
                },
                "efSa": "",
                "exwtXwraKwd": ""
            },
            "thlefwna": [],
            "user": {
                "mhtrwoArrenwn": "",
                "mobilePhone": "",
                "landlinePhone": "",
                "email": "",
                "isVerified": false,
                "isEmailVerified": false
            }
        };
    },

    Admin() {
        return {
            "strkProsKwd": "",
            "email": "example@email.gr",
            "yphrMonadaKwd": "",
            "yphrMonadaLek": "",
            "parakolMonada": this.AdiavMeeMona(),
            "onoma": "",
            "epwnymo": "",
            "afm": "",
            "amka": "",
            "workTelephone": ""
        };
    },

    AdiavMeeMona() {
        return {
            "efEaPinakaE": "",
            "monaLek": "",
            "sximatismoiKwd": "",
            "parentMonaKwd": "",
        }
    },

    Afm() {
        return {
            "efAfm": "",
            "efAmka": "",
            "efEmail": "",
            "efSa": ""
        }
    },

    Swmatometrika() {
        return {
            "efSa": "",
            "swmaBaros": 0,
            "swmaMhkosKavaloy": 0,
            "swmaMhkosPelmatos": 0,
            "swmaPerifLaimoy": 0,
            "swmaPerifMeshs": 0,
            "swmaPerifPelmatos": 0,
            "swmaPerifSththoys": 0,
            "swmaYpsos": 0
        }
    },

    Thlefwna() {
        return {
            efSa: "",
            thlAa: "",
            thlArith: "",
            thlefwnoPk: ""
        }
    },

    Announcement() {
        return {
            "anakoinwshLek": "",
            "attachments": [], // list of Attachment
            "content": "",
            "groups": []
        };
    },

    AnnouncementData() {
        return {
            content: "",
            moepKwd: 0,
            groups: [],
            attachments: [],
            anakoinwshLek: "",
            anakoinwshDate: "",
            anakoinwshStatus: "",
            sximatismoiKwd: "",
            groupSizes: {}
        };
    },

    Attachment() {
        return {
            "attachmentData": "",
            "attachmentName": ""
        };
    },

    Group() {
        return {
            "efedroiIds": [], // list of integers 
            "moepKwd": 0,
            "onoma": "",
            "perigrafh": ""
        };
    },

    /****************************************************/
    /*                      RESPONSES                   */
    /****************************************************/

    Municipality() {
        return {
            "policeDepts": [], // list of PoliceDept
            "communities": [], // list of GeoDept
            "token": ""
        };
    },

    PoliceDept() {
        return {
            "astEidosYphr": 0,
            "astKodikosIerarx": "",
            "astKodikosYphr": 0,
            "astKodikosYphrPal": 0,
            "astOdosArith": "",
            "astOnoma": "",
            "tkKodikos": ""
        };
    },

    GeoDept() {
        return {
            "astKodikosYphr": 0,
            "geoAm": 0,
            "geoArthro": 0,
            "geoDhm": "",
            "geoDhmos": "",
            "geoEda": "",
            "geoEndeixh": "",
            "geoEpa": "",
            "geoEparx": "",
            "geoEpistrNomosAlpha": 0,
            "geoKallikraths": "",
            "geoKathg": 0,
            "geoNom": "",
            "geoNomos": "",
            "geoNomosEpan": 0,
            "geoOikAa": "",
            "geoOnoma": "",
            "geoPlhthysmos": 0,
            "geoYpagwgh": "",
            "geoYpagwghEsye": "",
            "geoYpsom": 0,
            "tkKodikos": ""
        };
    },

    AdiavTaxis() {
        return {
            "adiavTaxisId": 0,
            "atomMoniAfm": "",
            "onomaM": "",
            "onomaP": "",
            "epwnymo1": "",
            "epwnymo2": "",
            "onoma": "",
            "birthPlace": "",
            "birthDate": "",
            "residenceAddress": "",
            "residenceAddressNo": "",
            "residenceZip": "",
            "residencePlace": "",
            "amka": "",
            "isAddrVerified": false,
        };
    }
};

